import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/pip/v1`;


export function getPerformanceModules() {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/performance_modules`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getPIP() {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/lists`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getPIPById(id) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/detail/${id}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}


export function createPIP(data) {
   return axios({
      method: "POST",
      headers: getHeaders(),
      url: `${url}/create`,
      data
   })
}

export function updatePIP(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/update/${id}`,
      data
   })
}

export function deletPIPById(id) {
   return axios({
      method: "DELETE",
      headers: getHeaders(),
      url: `${url}/archive/${id}`,
   });
}